import { TAppBindEvents } from '../types/events';

export const bindEvent: TAppBindEvents = (eventName, callback) => {
  const handler = (event: CustomEvent) => callback(event.detail);

  document.addEventListener(eventName, handler);

  return handler;
};
